import React, { useState } from 'react'
import { Icon } from '@fluentui/react/lib/Icon'
import PropTypes from 'prop-types'
import { useHistory, useLocation } from 'react-router-dom';
import qs from 'query-string';
import { SystemProvider } from '../../system/provider';
import { MenuHeader, Button, ButtonSort, SearchInput } from '../../../components';
import FilterForm from './form-sidebar';
import { QUERY_BLACKLIST as BLACKLIST } from '../../../constants';
import { useInternationalization } from '../../i18n';

const SwitcherStartEnd = () => <Icon iconName="SwitcherStartEnd" className="ms-SwitcherStartEnd text-xl" />;
const Filter = () => <Icon iconName="Filter" className="ms-Filter text-xl" />;

const FloatingFilter = ({onSubmit, onSort, filterOptions}) => {
  const history = useHistory()
  const [isOpen, setIsOpen] = React.useState(false)
  const { search, pathname } = useLocation()
  const currentParams = new URLSearchParams(search)
  const query = qs.parse(search)
  const queryKeys = Object.keys(query)
  const keyFilter = key => BLACKLIST.includes(key) === false
  const filteredKeys = queryKeys.filter(keyFilter)
  const [keyword, setKeyword] = useState('')
  const { translate } = useInternationalization()

  console.log({filterOptions})

  const handleSearchSubmit = (keyword) => {
    console.log(keyword)
    const currentParams = new URLSearchParams(search)
    let newQueryString = '?'+currentParams.toString()

    if(keyword && keyword.length > 0){
      if(currentParams.has('keyword')){
        currentParams.delete('keyword')
      }

      currentParams.append('keyword', keyword)

      newQueryString = '?'+currentParams.toString()
    }

    history.push({
      pathname,
      search: newQueryString
    })
  }

  const handleClick = () => {
    setIsOpen(false)
    onSubmit()
    handleSearchSubmit(keyword)
  }

  const sortOptions = [
    {
      key: 'date',
      value: 'newest',
      label: 'Newest',
      active: currentParams.get('date') === 'desc'
    },
    {
      key: 'date',
      value: 'oldest',
      label: 'Oldest',
      active: currentParams.get('date') === 'asc'
    }
  ]

  const isOrganization = currentParams.has('collection') && currentParams.get('collection') === 'organizations'

  if(isOrganization){
    sortOptions.push({
      key: 'name',
      value: 'az',
      label: 'Name: A-Z',
      active: currentParams.get('name') === 'asc'
    })
    sortOptions.push({
      key: 'name',
      value: 'za',
      label: 'Name: Z-A',
      active: currentParams.get('name') === 'desc'
    })
  } else {
    sortOptions.push({
      key: 'title',
      value: 'az',
      label: 'Title: A-Z',
      active: currentParams.get('sort_by_title') === 'asc'
    })
    sortOptions.push({
      key: 'title',
      value: 'za',
      label: 'Title: Z-A',
      active: currentParams.get('sort_by_title') === 'desc'
    })
  }

  const isSorted = currentParams.has('date') || currentParams.has('name') || currentParams.has('title')
  const isFiltered = filteredKeys.length > 0

  return (
    <div className="lg:hidden">

      {/* Trigger */}
      <div className="fixed bottom-0 fixed-center-horizontal mb-8">
        <div className="bg-white rounded-full w-auto mx-auto text-center" style={{boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15)'}}>
          <div className="flex items-center justify-center">
            <div className="rounded rounded-l-full py-2 px-4" onClick={() => setIsOpen('sort')}>
              <div className={`${isSorted ? 'text-primary' : 'text-gray-999'} text-xs font-bold flex items-center`}>
                <div className="mr-2"><SwitcherStartEnd /></div>
                <div>Sort</div>
              </div>
            </div>
            <div style={{height: '23px', width: '1px', background: '#ddd'}}/>
            <div className="rounded rounded-r-full py-2 px-4" onClick={() => setIsOpen('filter')}>
              <div className={`${isFiltered ? 'text-primary' : 'text-gray-999'} text-xs font-bold flex items-center`}>
                <div className="mr-2"><Filter /></div>
                <div>Filter</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Filter Menu */}
      {
        isOpen === 'filter' &&
        <div className="fixed left-0 top-0 h-screen w-full bg-white overflow-y-auto pb-10" style={{zIndex: 901}}>
          <MenuHeader className="bg-white z-10 fixed top-0 left-0 w-full" title="Filter" onClose={setIsOpen}/>
          <div className="p-5 pt-24">
            {
              (filterOptions && filterOptions.keyword) &&
              <div className="mb-8">
                <p className="font-bold text-sm mb-4">
                  {translate('SEARCH', 'search_by_keyword')}
                </p>
                <SearchInput
                  className="text-sm"
                  onChange={(e) => setKeyword(e.target.value)}
                />
              </div>
            }
            <SystemProvider>
              <FilterForm id="floating-filter-form" options={filterOptions ? {...filterOptions, keyword: false} : undefined}/>
            </SystemProvider>
          </div>
          <div className="w-full fixed bottom-0">
            <Button style={{borderRadius: 0}} onClick={handleClick}>Terapkan</Button>
          </div>
        </div>
      }

      {/* Sort Menu */}
      {
        isOpen === 'sort' &&
        <div className="fixed left-0 top-0 h-screen w-full bg-white overflow-y-auto pb-10" style={{zIndex: 901}}>
          <MenuHeader title="Sort" onClose={setIsOpen}/>
          <div className="p-5">
            {
              sortOptions.map(sortOption => (
                <ButtonSort
                  key={sortOption.value}
                  onClick={() => {setIsOpen(false); onSort(sortOption);}}
                  className="mr-3 mb-3"
                  active={sortOption.active}
                >
                  {sortOption.label}
                </ButtonSort>
              ))
            }
            {/* <ButtonSort onClick={() => onSort('alphabet')} className="mr-3 mb-3">Alphabet</ButtonSort>
            <ButtonSort onClick={() => onSort({key: 'date', value: 'newest'})} className="mr-3 mb-3" active>Newest</ButtonSort>
            <ButtonSort onClick={() => onSort({key: 'date', value: 'oldest'})} className="mr-3 mb-3">Oldest</ButtonSort>
            <ButtonSort onClick={() => onSort('popular')} className="mr-3 mb-3">Popular</ButtonSort> */}
          </div>
        </div>
      }
    </div>
  )
}

FloatingFilter.propTypes = {
  onSubmit: PropTypes.func
}

FloatingFilter.defaultProps = {
  onSubmit: () => {}
}

export { FloatingFilter }
